import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UtensilsCrossed } from "lucide-react";

export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (form.password.length < 6) return setErr("La password deve avere almeno 6 caratteri");
    if (form.password !== form.confirm) return setErr("Le due password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      setOk(true);
      setTimeout(() => nav("/login"), 1800);
    } catch (e) { setErr(apiErr(e)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6">
          <div className="grid h-10 w-10 place-items-center rounded-xl bg-primary text-white"><UtensilsCrossed className="h-6 w-6" /></div>
          <span className="font-heading font-bold text-lg text-slate-900">turismo.latina.it</span>
        </div>
        <h2 className="font-heading text-2xl font-bold text-slate-900">Reimposta la password</h2>

        {!token ? (
          <p className="mt-4 text-sm text-destructive">Link non valido: manca il token. Richiedi un nuovo link dalla pagina di accesso.</p>
        ) : ok ? (
          <p data-testid="reset-success" className="mt-4 text-sm text-emerald-600">Password aggiornata ✅ Ti reindirizzo all'accesso…</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label>Nuova password</Label><Input data-testid="reset-password-input" type="password" value={form.password} onChange={(e) => set("password", e.target.value)} placeholder="••••••••" required /></div>
            <div><Label>Conferma password</Label><Input data-testid="reset-confirm-input" type="password" value={form.confirm} onChange={(e) => set("confirm", e.target.value)} placeholder="••••••••" required /></div>
            {err && <p data-testid="reset-error" className="text-sm text-destructive">{err}</p>}
            <Button data-testid="reset-submit-btn" type="submit" disabled={loading} className="w-full rounded-xl h-11">
              {loading ? "Attendi..." : "Aggiorna password"}
            </Button>
          </form>
        )}
        <button type="button" onClick={() => nav("/login")} className="mt-4 w-full text-sm text-slate-500 hover:text-slate-900">← Torna all'accesso</button>
      </div>
    </div>
  );
}
